/* unplugin-vue-components disabled */import { render } from "./initiator.vue?vue&type=template&id=2f551026&scoped=true"
import script from "./initiator.vue?vue&type=script&lang=js"
export * from "./initiator.vue?vue&type=script&lang=js"

import "./initiator.vue?vue&type=style&index=0&id=2f551026&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f551026"]])

export default __exports__